var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDb24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.0824 17.9433C5.1313 18.5907 5.4037 18.9684 6.1615 18.9534C11.4448 18.8679 12.8317 12.4623 9.5674 9.44876C9.0436 8.96726 8.4082 8.57006 7.6414 8.30156C7.2559 8.16506 6.6208 7.96826 6.0793 7.96826C5.614 7.96826 5.218 8.11556 5.1151 8.57936C4.924 9.46496 5.0131 17.0649 5.0824 17.9433Z",
    fill: "url(#paint0_linear_3925_20122)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4536 2C12.0285 2 11.6709 2.1368 11.5758 2.5574C11.4015 3.3584 11.4855 10.2599 11.5455 11.06C11.5914 11.6444 11.8368 11.9867 12.5247 11.9771C17.3229 11.8964 18.5853 6.0809 15.621 3.3455C15.1461 2.9081 14.5635 2.5478 13.8735 2.3048C13.5213 2.1791 12.9462 2 12.4536 2Z",
    fill: "url(#paint1_linear_3925_20122)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6572 8.76901C12.434 9.77791 12.5417 18.4464 12.6185 19.4523C12.6776 20.1918 12.983 20.6169 13.8461 20.6043C19.8785 20.5077 21.464 13.1982 17.7395 9.75961C17.1443 9.21091 16.4102 8.75731 15.5429 8.45221C15.1007 8.29471 14.3753 8.07031 13.7603 8.07031C13.2269 8.07031 12.7727 8.23921 12.6572 8.76901Z",
    fill: "url(#paint2_linear_3925_20122)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3925_20122",
    x1: 5,
    y1: 18.9538,
    x2: 11.3197,
    y2: 18.9538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CB292B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3925_20122",
    x1: 11.4702,
    y1: 12.0653,
    x2: 17.322,
    y2: 12.0837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1CB0E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0462B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3925_20122",
    x1: 11.8878,
    y1: 21.8273,
    x2: 20.5298,
    y2: 21.8545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8BC53F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009B56"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDb24);
export default __webpack_public_path__ + "static/media/DB금융투자-24.9a5317501c4ca01cf11d4d0b7381fb62.svg";
export { ForwardRef as ReactComponent };